import { useState } from 'react';
import { NOTES } from '@/mocks/compare';
import { SectionHeading } from './ui';

export default function NotesSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Ghi chú"
        title="Ghi chú so sánh thị trường"
        subtitle="Những kiến thức ngắn gọn, khách quan về spread, swap và thông số sản phẩm."
      />

      <div className="mt-6 space-y-3">
        {NOTES.map((n, i) => {
          const isOpen = open === i;
          return (
            <div key={n.q} className="overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-50/50">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center gap-3 px-5 py-4 text-left"
              >
                <span className="flex-1 text-sm font-semibold text-slate-800">{n.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-violet-600 text-white' : 'bg-slate-200 text-slate-500'
                  }`}
                >
                  <i className={`ri-add-line text-base transition-transform ${isOpen ? 'rotate-45' : ''}`} />
                </span>
              </button>
              {isOpen && (
                <div className="border-t border-slate-200/70 px-5 py-4">
                  <p className="text-sm leading-relaxed text-slate-600">{n.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}